import { render, staticRenderFns } from "./HeaderPickupPoints.vue?vue&type=template&id=981c11f4&"
import script from "./HeaderPickupPoints.vue?vue&type=script&lang=js&"
export * from "./HeaderPickupPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports